import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';
import { IAppState } from 'store';
import { popMenuItem, pushMenuItem } from 'store/sidebar/actions';
import { TSidebarAction } from 'store/sidebar/types';

import Sidebar from './sidebar';

interface IDispatchProps {
    pushMenuItem(item: number): void;
    popMenuItem(): void;
}

interface IStateProps {
    isOpen: boolean;
    menuIndexChain: number[];
}

interface IOwnProps {
    isTouch?: boolean;
}

type TSidebarProps = IStateProps & IOwnProps;

function mapStateToProps(state: IAppState, ownProps: IOwnProps): TSidebarProps {
    const { isOpen, menuIndexChain } = state.sidebar;

    return { isOpen, menuIndexChain, isTouch: ownProps.isTouch };
}

function mapDispatchToProps(dispatch: Dispatch<TSidebarAction>): IDispatchProps {
    return bindActionCreators({
        pushMenuItem,
        popMenuItem
    }, dispatch);
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(Sidebar);
